import { DeepPartial } from '@apollo/client/utilities';
import {
  Order_By,
  Auth_User_Entity_Order_By,
  Cer_Order_By,
  GetAssetInCabinaIdsSubscription,
  GetCerFounderSubscription,
  GetCersSettingsSubscription,
  GetCersSubscription,
  GetConfigurazioneFounderSubscription,
  GetConfigurazioneGeomQuery,
  GetConfigurazioniCerSubscription,
  GetElencoIncentiviByCerCabinaIdSubscription,
  GetGeomCabinaQuery,
  GetLogRipartizioneSubscription,
  GetListaUtentiFounderQuery,
  SearchSottoscrizioniSubscription,
  GetSottoscrizioneFounderSubscription,
  Sottoscrizione_Order_By,
  Energy_Village__Stato_Sottoscrizione_Enum,
  // GetStagingLottiQuery,
  // GetStagingSottoscrizioneFounderQuery,
  // GetStagingSottoscrizioniQuery,
} from '../../../../_core/_graphql/generated';

export type FounderState = {
  settings_loading: boolean;

  settings_data?: GetCersSettingsSubscription['cer'];

  sottoscrizioni_loading: boolean;
  sottoscrizioni_data?: SearchSottoscrizioniSubscription['search_sottoscrizioni'];
  sottoscrizioni_stati_data?: Energy_Village__Stato_Sottoscrizione_Enum[];
  sottoscrizioni_filter: boolean;
  sottoscrizioni_filter_data: any;
  sottoscrizioni_search: string;
  sottoscrizioni_page: number;
  sottoscrizioni_page_size: number;
  sottoscrizioni_total: number;
  sottoscrizioni_active_filter: any;
  sottoscrizioni_order_by: Sottoscrizione_Order_By[];

  cabina_loading: boolean;
  cabina_data?: number[];

  selected_sottoscrizione_loading: boolean;
  selected_sottoscrizione?: GetSottoscrizioneFounderSubscription['sottoscrizione_by_pk'];

  cers_loading: boolean;
  cers_data?: GetCersSubscription['cer'];
  cers_filter: boolean;
  cers_active_filter: any;
  cers_page: number;
  cers_page_size: number;
  cers_total: number;
  cers_order_by: Cer_Order_By[];
  cers_search: string;
  selected_cer_loading: boolean;
  selected_cer?: GetCerFounderSubscription['cer_by_pk'];

  configurazioni_data?: GetConfigurazioniCerSubscription['cer'];
  configurazioni_loading: boolean;
  configurazioni_filter: boolean;
  configurazioni_active_filter: any;
  configurazioni_page: number;
  configurazioni_page_size: number;
  configurazioni_total: number;
  configurazioni_order_by: Cer_Order_By[];
  configurazioni_search: string;
  selected_configurazione_loading: boolean;
  selected_configurazione?: GetConfigurazioneFounderSubscription['cer_by_pk'];
  selected_configurazione_geometrie: Record<
    string,
    GetGeomCabinaQuery['energy_village_area'][0]
  >;
  selected_configurazione_geometria: GetConfigurazioneGeomQuery['cer_geom_by_pk'];
  selected_configurazione_assets: GetAssetInCabinaIdsSubscription['asset'];

  selected_configurazione_selected_cabina_loading: boolean;
  selected_configurazione_selected_cabina?: NonNullable<
    GetConfigurazioneFounderSubscription['cer_by_pk']
  >['cer_cabina'][0];

  selected_configurazione_incentivi_loading: boolean;
  selected_configurazione_incentivi_data?: GetElencoIncentiviByCerCabinaIdSubscription['incentivi_ripartizione'];

  // staging_sottoscrizione_loading: boolean;
  // staging_sottoscrizione_data?: DeepPartial<
  //   GetStagingSottoscrizioniQuery['staging_sottoscrizione']
  // >;
  // selected_staging_sottoscrizione?: DeepPartial<
  //   GetStagingSottoscrizioneFounderQuery['staging_sottoscrizione_by_pk']
  // >;
  // staging_lotti_loading: boolean;
  // staging_lotti_data?: DeepPartial<GetStagingLottiQuery['staging_lotto']>;
  // selected_lotto?: DeepPartial<GetStagingLottiQuery['staging_lotto'][0]>;

  selected_log_ripartizione_loading: boolean;
  selected_log_ripartizione_data?: DeepPartial<
    GetLogRipartizioneSubscription['incentivi_log_ripartizione']
  >;

  lista_utenti_loading: boolean;
  lista_utenti_data?: GetListaUtentiFounderQuery['search_user_entity'];
  lista_utenti_order_by: Auth_User_Entity_Order_By[];
  lista_utenti_search: string;
  lista_utenti_active_filter: {
    whitelabel?: string[];
    tipologia_profilo?: string[];
  };
  lista_utenti_page: number;
  lista_utenti_page_size: number;
  lista_utenti_total: number;

  lista_utenti_whitelabels_loading: boolean;
  lista_utenti_whitelabels_data?: { referral: string }[];

  failure?: any;
};

export const initialFounderState: FounderState = {
  settings_loading: true,

  settings_data: undefined,

  cabina_loading: false,
  cabina_data: undefined,

  sottoscrizioni_loading: true,
  sottoscrizioni_data: undefined,
  sottoscrizioni_stati_data: undefined,
  sottoscrizioni_filter: false,
  sottoscrizioni_filter_data: undefined,
  sottoscrizioni_search: '',
  sottoscrizioni_page: 0,
  sottoscrizioni_page_size: 10,
  sottoscrizioni_total: 0,
  sottoscrizioni_active_filter: undefined,
  sottoscrizioni_order_by: [{ updated_at: Order_By.Desc }],

  selected_sottoscrizione_loading: true,
  selected_sottoscrizione: undefined,

  cers_loading: true,
  cers_data: undefined,
  cers_filter: false,
  cers_active_filter: undefined,
  cers_page: 0,
  cers_page_size: 10,
  cers_total: 0,
  cers_order_by: [{ abilita_richieste: Order_By.Desc }, { stato_cer: Order_By.Asc }, { created_at: Order_By.Desc }],
  cers_search: '',

  selected_cer_loading: true,
  selected_cer: undefined,

  configurazioni_loading: true,
  configurazioni_data: undefined,
  configurazioni_filter: false,
  configurazioni_active_filter: undefined,
  configurazioni_page: 0,
  configurazioni_page_size: 10,
  configurazioni_total: 0,
  configurazioni_order_by: [{ stato_cer: Order_By.Desc }, { created_at: Order_By.Desc }],
  configurazioni_search: '',
  selected_configurazione_loading: true,
  selected_configurazione: undefined,

  selected_configurazione_geometria: undefined,
  selected_configurazione_geometrie: {},
  selected_configurazione_assets: [],

  selected_configurazione_incentivi_loading: true,
  selected_configurazione_incentivi_data: undefined,

  selected_configurazione_selected_cabina_loading: true,
  selected_configurazione_selected_cabina: undefined,

  // staging_sottoscrizione_loading: true,
  // staging_sottoscrizione_data: undefined,
  // selected_staging_sottoscrizione: undefined,

  // staging_lotti_loading: true,
  // staging_lotti_data: undefined,
  // selected_lotto: undefined,

  selected_log_ripartizione_loading: true,
  selected_log_ripartizione_data: undefined,

  lista_utenti_loading: false,
  lista_utenti_data: undefined,
  lista_utenti_order_by: [{ first_name: Order_By.Asc }],
  lista_utenti_search: '',
  lista_utenti_active_filter: {},
  lista_utenti_page: 0,
  lista_utenti_page_size: 10,
  lista_utenti_total: 0,

  lista_utenti_whitelabels_loading: false,
  lista_utenti_whitelabels_data: undefined,

  failure: undefined,
};
